import { connect } from 'react-redux';
import { MultiDisciplineSelect } from './MultiDisciplineSelect';

const mapStateToProps = (state) => ({
  user: state.user.get('data'),
});

export default connect(mapStateToProps)(MultiDisciplineSelect);
